import type { ClspMode } from '../../types'
import type { Match } from '../../types/match'
import { requestApiJsonOrThrow } from '../request-handler'

type GetMatchCentreMatchParams = {
  id: string
  mode: ClspMode | 'postMatch'
  bypassLookup: boolean
}

function getMatchCentreMatch(params: GetMatchCentreMatchParams): Promise<Match> {
  const { id, mode, bypassLookup } = params

  return requestApiJsonOrThrow<Match>(`match/${id}`, {
    params: {
      mode,
      bypassLookup: bypassLookup ? 'true' : undefined,
    },
  })
}

export const matchCentreMatchQuery = (params: GetMatchCentreMatchParams) => ({
  queryKey: ['match-centre-match', params],
  queryFn: () => getMatchCentreMatch(params),
})
